import * as React from 'react';
import { Page } from 'common/components/layout/Page';
import * as releaseNotes from '!raw-loader!./RELEASE_NOTES.html';
const RELEASE_NOTES_META = require('./RELEASE_NOTES_META.json');
import './ReleaseNotes.css';

export class ReleaseNotes extends React.Component {
  componentDidMount() {
    window.localStorage.setItem('lastReleaseNoteViewDate', RELEASE_NOTES_META[0]);
  }
  render() {
    return (
      <Page title="Release Notes">
        <div className="p-3 p-md-0 release-notes" dangerouslySetInnerHTML={{ __html: releaseNotes }} />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/ReleaseNotes/ReleaseNotes.tsx